import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoBranchUserDetailed} from "./models/DtoBranchUserDetailed";

@Injectable()
export class BranchesListService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'user'
    }

    public getBranchesDetailed = (): Observable<DtoBranchUserDetailed[]> => {
        return this.http.get<DtoBranchUserDetailed[]>(`${this.apiUrl}/branches/detailed`);
    };

    public createBranchOtp = (userId: number): Observable<string> => {
        return this.http.post<string>(`${this.apiUrl}/branches/otp/${userId}`, null);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/branches/branches-list/branches-list.service.ts